import React, { useEffect } from "react";

import AddFirstGig from "./AddFirstGig";
import BenifitOfGettingVerifiedPopup from "./BenifitOfGettingVerifiedPopup";
import FirstTimeLoginPopup from "./FirstTimeLoginPopup";
import ProfileCompletionPopup from "./ProfileCompletionPopup";

const PopupWrapperComponent = () => {
  return (
    <>
      <FirstTimeLoginPopup />
      <ProfileCompletionPopup />
      <AddFirstGig />
      <BenifitOfGettingVerifiedPopup />
    </>
  );
};

export default PopupWrapperComponent;
